import { Button } from '@cluey/cluey-components';
import { useQueryClient } from '@tanstack/react-query';
import { memo, useState } from 'react';

import { BillingInformationType } from '../../../../../types/hubPropTypes';
import { GET_BILLING_INFORMATION_QKEY } from '../../../../../util/constants/queryKeys';
import { PaymentMethodForm } from './PaymentMethod/PaymentMethodForm';

export type SavedPaymentDetailsProps = {
  billingInformation: BillingInformationType;
  onSuccess: () => void;
};

const SavedPaymentDetails = memo(({ billingInformation = {}, onSuccess }: SavedPaymentDetailsProps) => {
  const queryClient = useQueryClient();
  const { endingIn, creditCardType } = billingInformation ?? {};
  const [paymentMethodViewEditMode, setPaymentMethodViewEditMode] = useState<'view' | 'edit'>(
    !endingIn || !creditCardType ? 'edit' : 'view'
  );

  if (paymentMethodViewEditMode === 'view') {
    return (
      <div>
        <h3 className="mb-3 font-display font-bold">Payment details</h3>
        {creditCardType && endingIn && (
          <div>
            <p className="mb-0 pb-4 leading-none">Credit card ending **** {endingIn?.replace(/\*/g, '')}</p>
            <p className="pb-4 text-xs italic">
              If you've just updated your payment details it may take a little while for it to be reflected.
            </p>
          </div>
        )}
        <Button
          appearance="reverse"
          size="xs"
          onClick={() => {
            setPaymentMethodViewEditMode('edit');
          }}
        >
          EDIT PAYMENT DETAILS
        </Button>
      </div>
    );
  } else if (paymentMethodViewEditMode === 'edit') {
    return (
      <PaymentMethodForm
        zuoraAccountId={billingInformation?.zuoraId}
        onCancel={() => {
          queryClient.invalidateQueries({ queryKey: [GET_BILLING_INFORMATION_QKEY] });
          setPaymentMethodViewEditMode('view');
        }}
        onSuccess={() => {
          queryClient.invalidateQueries({ queryKey: [GET_BILLING_INFORMATION_QKEY] });
          setPaymentMethodViewEditMode('view');
          onSuccess?.();
        }}
      />
    );
  }
  return null;
});

export default SavedPaymentDetails;
